// extracted by mini-css-extract-plugin
export default {"medataContainer":"style_medataContainer__h0CLh","cardMetadata":"style_cardMetadata__awfv1"};